var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeEmpty = function SvgVolumeEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.18 3.683 6 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3l5.18 4.317a.5.5 0 0 0 .82-.384V4.068a.5.5 0 0 0-.82-.385ZM4 10h2.724L10 7.27v9.46L6.724 14H4v-4Zm10-2a4 4 0 0 1 0 8v-2a2 2 0 1 0 0-4V8Zm0-4a8 8 0 1 1 0 16v-2a6 6 0 0 0 0-12V4Z"
  })));
};
export default SvgVolumeEmpty;